import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';
import * as uuid from 'uuid';
import { CBParams, ClientSummaryOptions } from '../gateway.config';
@Injectable({ providedIn: 'root' })
export class AppStateGateway {
  constructor(private _urlFactory: UrlFactory) {}

  rfiViewallExternal = (entitlement: string) =>
    entitlement === 'ma-view-all-rfi-ext';
  maBobExternal = (entitlement: string) =>
    entitlement === 'smenu-ma-book-business-ext';
  maAppStatusExternal = (entitlement: string) =>
    entitlement === 'smenu-ma-applic-status-ext';

  getAlerts(): string {
    return this._urlFactory.createUrl('getAlert', '', {
      service_reference_id: uuid.v4(),
    });
  }
  dismissAlert(): string {
    return this._urlFactory.createUrl('dismissAlert', '', {
      service_reference_id: uuid.v4(),
    });
  }
  getUserAgreement(callareaParam: string, category: string): string {
    return this._urlFactory.createUrl('getContentHub', category, {
      callarea: callareaParam,
      service_reference_id: uuid.v4(),
    });
  }
  updateTermsAgreementStatus(): string {
    return this._urlFactory.createUrl('userAgreementUpdate', '', {
      service_reference_id: uuid.v4(),
    });
  }
  getNavigations(): string {
    const groupId = localStorage.getItem('group-id');
    const queryParam = {
      service_reference_id: uuid.v4(),
    };
    const cs1IdParam = {
      ...queryParam,
      cs1Id: '',
    };
    if (groupId) {
      cs1IdParam.cs1Id = groupId;
    }
    return this._urlFactory.createUrl(
      'getNavigations',
      '',
      groupId ? cs1IdParam : queryParam,
    );
  }

  getWelcomeTile(): string {
    return this._urlFactory.createUrl('getBrokerWelcome', '', {});
  }
  getBusinessAlert(): string {
    return this._urlFactory.createUrl('getBusinessAlert', '', {});
  }
  searchClient(): string {
    return this._urlFactory.createUrl('searchClient', '', {
      service_reference_id: uuid.v4(),
    });
  }
  checkIpValid(): string {
    return this._urlFactory.createUrl('checkIpValid', '', {
      service_reference_id: uuid.v4(),
    });
  }

  getCompensationStatements(getStatementRequest: {
    contact_peid: string;
  }): string {
    return this._urlFactory.createUrl(
      'getCompensationStatements',
      'search/statements',
      getStatementRequest,
    );
  }

  getFilterCompensationStatements(): string {
    return this._urlFactory.createUrl(
      'getCompensationStatements',
      'search/filter-statements',
    );
  }

  printStatement(printStatementRequest: {
    producer_code: string;
    statement_dt: string;
  }): string {
    return this._urlFactory.createUrl(
      'getCompensationStatements',
      'statements/pdf-statement',
      printStatementRequest,
    );
  }

  printCsvStatement(printStatementRequest: {
    producer_code: string;
    statement_dt: string;
  }): string {
    return this._urlFactory.createUrl(
      'getCompensationStatements',
      'statements/csv-statement',
      printStatementRequest,
    );
  }
  getOktaExtRedirect(targetUrl: string): string {
    const encodedUri = encodeURIComponent(targetUrl);
    return (
      this._urlFactory.createUrl('getOktaExtRedirect', '', {}) + encodedUri
    );
  }
  getDefaultPath(): string {
    return this._urlFactory.createUrl('defaultPath', '', {});
  }

  getKeepAlive(): string {
    return this._urlFactory.createUrl('getKeepAlive', '', {});
  }

  getAgentViewOktaExtRedirect(targetUrl: string): string {
    const encodedUri = encodeURIComponent(targetUrl);
    return (
      this._urlFactory.createUrl('getAgentViewOktaExtRedirect', '', {}) +
      encodedUri
    );
  }

  getKaplanEmail(): string {
    return this._urlFactory.createUrl('kaplanEmail', '', {});
  }

  getFirmsList(): string {
    return this._urlFactory.createUrl('getFirmsList', '', {});
  }
  getStatementsList(): string {
    return this._urlFactory.createUrl('getStatementsList', '', {});
  }
  getRFPData(): string {
    return this._urlFactory.createUrl('getRFPData', '', {});
  }
  getClientManagerList(): string {
    return this._urlFactory.createUrl('getClientManagerList', '', {});
  }
  getProfileUserMatch(): string {
    return this._urlFactory.createUrl('getProfileUserMatch', '', {});
  }
  getCFEFederationUrl(): string {
    return this._urlFactory.createExtUrl('getCFEFederationUrl', '', {});
  }
  getPartnerIdUrl(): string {
    return this._urlFactory.createUrl('getPartnerId', '', {});
  }
  getMessagesList(): string {
    return this._urlFactory.createUrl('getMessagesList', '', {});
  }
  addAgency(): string {
    return this._urlFactory.createUrl('addAgency', '', {});
  }
  getBRProfile(): string {
    return this._urlFactory.createUrl('getBRProfile', '', {});
  }
  getBrokerQuoteMedical(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteMedical', '', {});
  }
  getIfpMedicalAgency(): string {
    return this._urlFactory.createExtUrl('getIfpMedicalAgency', '', {});
  }
  getBrokerQuoteDental(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteDental', '', {});
  }
  getBrokerQuoteAdvantage(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteAdvantage', '', {});
  }
  getBrokerQuoteAdvantage2022(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteAdvantage2022', '', {});
  }
  getBrokerQuoteAdvantage2025(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteAdvantage2025', '', {});
  }
  getBrokerQuoteBenefits(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteBenefits', '', {});
  }
  getBrokerBobCommercial(): string {
    return this._urlFactory.createExtUrl('getBrokerBobCommercial', '', {});
  }
  getBrokerBobPlans(): string {
    return this._urlFactory.createExtUrl('getBrokerBobPlans', '', {});
  }
  getBrokerBobAdvantage(): string {
    return this._urlFactory.createExtUrl('getBrokerBobAdvantage', '', {});
  }
  getBrokerBobBenefits(): string {
    return this._urlFactory.createExtUrl('getBrokerBobBenefits', '', {});
  }
  removeAgency(): string {
    return this._urlFactory.createUrl('removeAgency', '', {});
  }
  getAgencyList(): string {
    return this._urlFactory.createUrl('getAgencyList', '', {});
  }
  postAffirm(): string {
    return this._urlFactory.createUrl('postAffirm', '', {});
  }
  getSepWorkQExtUrl(): string {
    return this._urlFactory.createUrl('getSepWorkQExtUrl', '', {});
  }
  getIfpMedicalAdmin(): string {
    return this._urlFactory.createExtUrl('getIfpMedicalAdmin', '', {});
  }
  getSepWorkQIntAdmin(): string {
    return this._urlFactory.createUrl('getSepWorkQIntAdmin', '', {});
  }
  getBrokerQuoteDentalAdmin(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteDentalAdmin', '', {});
  }
  getBrokerQuoteDentalNew(): string {
    return this._urlFactory.createExtUrl('getBrokerQuoteDentalNew', '', {});
  }
  getSepWorkQIntUrl(): string {
    return this._urlFactory.createExtUrl('getSepWorkQIntUrl', '', {});
  }
  getIfpAdminUrl(): string {
    return this._urlFactory.createExtUrl('getIfpAdminUrl', '', {});
  }
  getComReqProposal(): string {
    return this._urlFactory.createExtUrl('getComReqProposal', '', {});
  }
  getComComp(): string {
    return this._urlFactory.createUrl('getComComp', '', {});
  }
  getComTraining(): string {
    return this._urlFactory.createExtUrl('getComTraining', '', {});
  }
  getComSolutionInsight(): string {
    return this._urlFactory.createExtUrl('getComSolutionInsight', '', {});
  }
  getBrokerSecurityProfileUrl(): string {
    return this._urlFactory.createUrl('getBrokerSecurityProfileUrl', '', {});
  }
  getSpotlight(): string {
    return this._urlFactory.createUrl('getSpotlight', '', {});
  }
  getTools(): string {
    return this._urlFactory.createUrl('getTools', '', {});
  }
  getNotifications(): string {
    return this._urlFactory.createUrl('getNotifications', '', {
      service_reference_id: uuid.v4(),
    });
  }
  requestForInfo(): string {
    return this._urlFactory.createUrl('getRequestForInfo', '', {});
  }
  getApplicantRfiInternal(salesForceId: string): string {
    return this._urlFactory
      .createUrl('getApplicantRfiInternal', '', {})
      .replace('{salesForceId}', salesForceId);
  }
  getApplicantRfiExternal(salesForceId: string): string {
    return this._urlFactory
      .createUrl('getApplicantRfiExternal', '', {})
      .replace('{salesForceId}', salesForceId);
  }
  getViewAllRfiInternal(): string {
    return this._urlFactory.createUrl('getViewAllRfiInternal', '', {});
  }
  getViewAllRfiExternal(): string {
    return this._urlFactory.createUrl('getViewAllRfiExternal', '', {});
  }
  getViewAllRfiUrl(entitlements: string[]): string {
    const isRfiViewAllExt = entitlements.some(this.rfiViewallExternal);
    return isRfiViewAllExt
      ? this.getViewAllRfiExternal()
      : this.getViewAllRfiInternal();
  }
  getMaBobUrl(entitlements: string[]): string {
    const isMaBoblExt = entitlements?.some(this.maBobExternal);
    return isMaBoblExt ? this.getMABOBExt() : this.getMABOBInt();
  }
  getMaAppStatusUrl(entitlements: string[]): string {
    const isMaAppStatusExt = entitlements?.some(this.maAppStatusExternal);
    return isMaAppStatusExt
      ? this.getMAAppStatusExt()
      : this.getMAAppStatusInt();
  }
  // ISAM config:
  getBrokerClientId(): string {
    return this._urlFactory.createUrl('clientId', '', {});
  }
  getBrokerMetadataUri(): string {
    return this._urlFactory.createUrl('metadataUri', '', {});
  }
  getBrokerAuthorizeUri(): string {
    return this._urlFactory.createUrl('authorizeUri', '', {});
  }
  getBrokerRedirectUri(): string {
    return this._urlFactory.createUrl('redirectUri', '', {});
  }
  getBrokerCfbUrl(): string {
    return this._urlFactory.createUrl('cfbApiUrl', '', {});
  }
  getBrokerGsgUrl(): string {
    return this._urlFactory.createUrl('gsgApiUrl', '', {});
  }
  getMAQE(): string {
    return this._urlFactory.createUrl('getMAQE', '', {});
  }
  getMABOBInt(): string {
    return this._urlFactory.createExtUrl('getMABOBInt', '', {});
  }
  getMABOBExt(): string {
    return this._urlFactory.createExtUrl('getMABOBExt', '', {});
  }
  getMAAppStatusInt(): string {
    return this._urlFactory.createExtUrl('getMAAppStatusInt', '', {});
  }
  getMAAppStatusExt(): string {
    return this._urlFactory.createExtUrl('getMAAppStatusExt', '', {});
  }
  getCsbQuoteEnroll(): string {
    return this._urlFactory.createExtUrl('getCsbQuoteEnroll', '', {});
  }
  getQuoteEnrollOtherStates(): string {
    return this._urlFactory.createExtUrl('getQuoteEnrollOtherStates', '', {});
  }
  redirectToNewPortalUrl(): string {
    return this._urlFactory.createExtUrl('redirectToNewPortalUrl', '', {});
  }
  redirectToUpcomingEvents(): string {
    return this._urlFactory.createExtUrl('upcomingEvents', '', {});
  }
  getUpcomingEvents(): string {
    return this._urlFactory.createExtUrl('getUpcomingEvents', '', {});
  }
  getCsbBob(): string {
    return this._urlFactory.createUrl('getCsbBob', '', {});
  }
  getCsbCompensation(): string {
    return this._urlFactory.createUrl('getCsbCompensation', '', {});
  }
  getCsbCompensation_v1(): string {
    return this._urlFactory.createUrl('getCsbCompensation_v1', '', {});
  }
  getCsbSalesMarketingMtrl(): string {
    return this._urlFactory.createExtUrl('getCsbSalesMarketingMtrl', '', {});
  }
  getCsbSalesMarketingMtrl_v1(): string {
    return this._urlFactory.createExtUrl('getCsbSalesMarketingMtrl_v1', '', {});
  }
  getCsbIncentives(): string {
    return this._urlFactory.createExtUrl('getCsbIncentives', '', {});
  }
  getCsbMyCustomers(): string {
    return this._urlFactory.createExtUrl('getCsbMyCustomers', '', {});
  }
  getNewCsbBob(): string {
    return this._urlFactory.createExtUrl('getNewCsbBob', '', {});
  }
  getCsbPolicyReporting_v1(): string {
    return this._urlFactory.createExtUrl('getCsbPolicyReporting_v1', '', {});
  }
  getCsbPolicyReporting(): string {
    return this._urlFactory.createExtUrl('getCsbPolicyReporting', '', {});
  }
  getCsbAgentInquiry_v1(): string {
    return this._urlFactory.createExtUrl('getCsbAgentInquiry_v1', '', {});
  }
  getCsbAgentInquiry(): string {
    return this._urlFactory.createExtUrl('getCsbAgentInquiry', '', {});
  }
  getCsbRecruiting(): string {
    return this._urlFactory.createExtUrl('getCsbRecruiting', '', {});
  }
  getCsbTraining(): string {
    return this._urlFactory.createExtUrl('getCsbTraining', '', {});
  }
  getCsbTraining_v1(): string {
    return this._urlFactory.createExtUrl('getCsbTraining_v1', '', {});
  }
  getCsbProductInfo(): string {
    return this._urlFactory.createExtUrl('getCsbProductInfo', '', {});
  }
  getCsbBusinessBuilding(): string {
    return this._urlFactory.createExtUrl('getCsbBusinessBuilding', '', {});
  }
  getCsbBenefits(): string {
    return this._urlFactory.createExtUrl('getCsbBenefits', '', {});
  }
  getCsbServicingForms(): string {
    return this._urlFactory.createExtUrl('getCsbServicingForms', '', {});
  }
  getCsbToolsExpressApp(): string {
    return this._urlFactory.createExtUrl('getCsbToolsExpressApp', '', {});
  }
  getCsbToolsExpressWay(): string {
    return this._urlFactory.createExtUrl('getCsbToolsExpressWay', '', {});
  }
  getBrokerBobMaApplication(): string {
    return this._urlFactory.createExtUrl('getBrokerBobMaApplication', '', {});
  }
  getIfpCompExt(): string {
    return this._urlFactory.createExtUrl('getIfpCompExt', '', {});
  }
  getIfpCompInt(): string {
    return this._urlFactory.createUrl('getIfpCompInt', '', {});
  }
  getIfpResourceCenterExt(): string {
    return this._urlFactory.createExtUrl('getIfpResourceCenterExt', '', {});
  }
  addAdminRelationship(): string {
    return this._urlFactory.createUrl('addAdminRelationship', '', {});
  }
  getComContinueEdu(): string {
    return this._urlFactory.createExtUrl('getComContinueEdu', '', {});
  }
  getComProDir(): string {
    return this._urlFactory.createUrl('getComProDir', '', {});
  }
  getComCigna(): string {
    return this._urlFactory.createUrl('getComCigna', '', {});
  }
  getComPreDrugList(): string {
    return this._urlFactory.createUrl('getComPreDrugList', '', {});
  }
  getComCfe(): string {
    return this._urlFactory.createUrl('getComCfe', '', {});
  }
  getTimeoutDuration(): string {
    return this._urlFactory.createUrl('getTimeoutDuration', '', {});
  }
  getLogoutDuration(): string {
    return this._urlFactory.createUrl('getLogoutDuration', '', {});
  }
  getStaySignin(): string {
    return this._urlFactory.createUrl('metadataUri', '', {});
  }
  getImpersonatorSwitchUserTimeoutDuration(): string {
    return this._urlFactory.createUrl(
      'getImpersonatorSwitchUserTimeoutDuration',
      '',
      {},
    );
  }
  getImpersonatorSwitchUserLogoutDuration(): string {
    return this._urlFactory.createUrl(
      'getImpersonatorSwitchUserLogoutDuration',
      '',
      {},
    );
  }
  getUserSession(): string {
    return this._urlFactory.createExtUrl('getUserSession', '', {});
  }
  getIfpMedicalExtAgent(): string {
    return this._urlFactory.createExtUrl('getIfpMedicalExtAgent', '', {});
  }
  getSolutionsInsights(): string {
    return this._urlFactory.createUrl('getSolutionsInsights', '', {});
  }
  sendPostLoginContactUsEmailNotification(): string {
    return this._urlFactory.createUrl(
      'sendPostLoginContactUsEmailNotification',
      '',
      {},
    );
  }
  getCurrentBusiness(options: CBParams): string {
    return this._urlFactory.createUrl('getCurrentBusinessData', '', options);
  }

  verifyUserData(): string {
    return this._urlFactory.createUrl('verifyUserData', '', {});
  }
  verifySecurity(): string {
    return this._urlFactory.createUrl('verifySecurity', '', {});
  }
  verifyFactorUrl(): string {
    return this._urlFactory.createUrl('verifyFactorUrl', '', {});
  }
  getClientSummaryData(options: ClientSummaryOptions): string {
    return this._urlFactory.createUrl('getClientSummaryData', '', options);
  }
  getClientManagerData(): string {
    return this._urlFactory.createUrl('getClientManagerData', '', {});
  }
  getMaCompensationStatements(): string {
    return this._urlFactory.createUrl('getMaCompensationStatements', '', {});
  }
  getSgRenewals(): string {
    return this._urlFactory.createUrl('getSgRenewals', '', {});
  }
  getSgRenewalDownload(printStatementRequest: {
    renewalPackageId: string;
    service_reference_id: string;
  }): string {
    return this._urlFactory.createUrl(
      'getSgRenewalDownload',
      'package',
      printStatementRequest,
    );
  }
  getOnDemandExploreContent(): string {
    return this._urlFactory.createExtUrl('getOnDemandExploreContent', '', {});
  }
  getContinuingEdExploreCatalog(): string {
    return this._urlFactory.createExtUrl(
      'getContinuingEdExploreCatalog',
      '',
      {},
    );
  }
  getContinuingEdExploreCatalogNew(): string {
    return this._urlFactory.createExtUrl(
      'getContinuingEdExploreCatalogNew',
      '',
      {},
    );
  }
  downloadMaCompXls(): string {
    return this._urlFactory.createUrl('downloadMaCompXls', '', {});
  }
  getMedicareEligibilityLookup(): string {
    return this._urlFactory.createUrl('getMedicareEligibilityLookup', '', {});
  }
  getMedicaidEligibilityLookup(): string {
    return this._urlFactory.createUrl('getMedicaidEligibilityLookup', '', {});
  }
  getTokenLookup(): string {
    return this._urlFactory.createUrl('getTokenRequest', '', {});
  }
  getTermsOfUse(): string {
    return this._urlFactory.createExtUrl('getTermsOfUse', '', {});
  }
  getPrivacyPolicy(): string {
    return this._urlFactory.createExtUrl('getPrivacyPolicy', '', {});
  }
  getCFELoginLink(): string {
    return this._urlFactory.createExtUrl('getCFELoginLink', '', {});
  }
  getMaCompPaymentScheduleUrl(): string {
    return this._urlFactory.createUrl('getMaCompPaymentScheduleUrl', '', {});
  }
  getFilteredCompReportsUrl(): string {
    return this._urlFactory.createUrl(
      'getCompReportsList',
      'client-compensation-search',
      {},
    );
  }
  getCompReportsListUrl(getCompReportsRequest: { peid: string }): string {
    return this._urlFactory.createUrl(
      'getCompReportsList',
      'client-compensation',
      getCompReportsRequest,
    );
  }
  getRequestNewAccessCodeUrl(): string {
    return this._urlFactory.createUrl(
      'getRequestNewAccessCodeUrl',
      'process-access-request',
      {},
    );
  }
  getAccessCodeValidation(): string {
    return this._urlFactory.createUrl('getAccessCodeValidation', '', {});
  }
  getAccessCodeValidationIntegration(): string {
    return this._urlFactory.createUrl(
      'getAccessCodeValidationIntegration',
      '',
      {},
    );
  }
  getRegistrationSubmit(): string {
    return this._urlFactory.createUrl('getRegistrationSubmit', '', {});
  }
  getRegistrationSubmitIntegration(): string {
    return this._urlFactory.createUrl(
      'getRegistrationSubmitIntegration',
      '',
      {},
    );
  }
  getUsernameValidation(): string {
    return this._urlFactory.createUrl('getUsernameValidation', '', {});
  }
  getSnowUrl(): string {
    return this._urlFactory.createUrl('getSnowUrl', '', {});
  }
  accessCdValidateEmail(): string {
    return this._urlFactory.createUrl('accessCdValidateEmail', '', {});
  }
  profilePreLoad(): string {
    return this._urlFactory.createUrl('profilePreLoad', '', {
      service_reference_id: uuid.v4(),
    });
  }
  profilePreLoadKey(): string {
    return this._urlFactory.createUrl('profilePreLoadKey', '', {});
  }
  printCsvCompReportsUrl(): string {
    return this._urlFactory.createUrl(
      'getCompReportsList',
      'client-compensation-csv',
      {},
    );
  }
  getUserLoginDateUpdateUrl(): string {
    return this._urlFactory.createUrl('lastLoginDateUpdate', '', {});
  }
  sendPreLoginContactUsEmailNotification(): string {
    return this._urlFactory.createUrl(
      'sendPreLoginContactUsEmailNotification',
      '',
      {},
    );
  }
  resetPassword(): string {
    return this._urlFactory.createUrl('resetPasswordUrl', '', {});
  }
  getStateTokenData(): string {
    return this._urlFactory.createUrl('stateTokenUrl', '', {});
  }

  saveSecurityQuestion(): string {
    return this._urlFactory.createUrl('saveSecurityQuestion', '', {});
  }

  changePassword(): string {
    return this._urlFactory.createUrl('changePassword', '', {});
  }
  getSecurityProfileUserData(): string {
    return this._urlFactory.createUrl('getSecurityProfileUserData', '', {});
  }
  getSecurityProfileDetails(): string {
    return this._urlFactory.createUrl('getSecurityProfileDetails', '', {});
  }
  getSecurityProfileFactorsData(): string {
    return this._urlFactory.createUrl('getSecurityProfileFactorsData', '', {});
  }
  addSecurityProfileEmailFactor(): string {
    return this._urlFactory.createUrl('addSecurityProfileEmailFactor', '', {});
  }
  addSecurityProfileMobileFactor(): string {
    return this._urlFactory.createUrl('addSecurityProfileMobileFactor', '', {});
  }
  activateSecurityProfileMobileFactor(): string {
    return this._urlFactory.createUrl(
      'activateSecurityProfileMobileFactor',
      '',
      {},
    );
  }
  activateSecurityProfileEmailFactor(): string {
    return this._urlFactory.createUrl(
      'activateSecurityProfileEmailFactor',
      '',
      {},
    );
  }
  resendSecurityProfileMobileFactor(): string {
    return this._urlFactory.createUrl(
      'resendSecurityProfileMobileFactor',
      '',
      {},
    );
  }
  resendecurityProfileEmailFactor(): string {
    return this._urlFactory.createUrl(
      'resendecurityProfileEmailFactor',
      '',
      {},
    );
  }

  verifyPasscode(): string {
    return this._urlFactory.createUrl('verifyPasscode', '', {});
  }
  getForgotUsernameFindUserData(): string {
    return this._urlFactory.createUrl('getForgotUsernameFindUserData', '', {});
  }
  getForgotUsernameVerifyUserData(): string {
    return this._urlFactory.createUrl(
      'getForgotUsernameVerifyUserData',
      '',
      {},
    );
  }
  validateEmail(): string {
    return this._urlFactory.createUrl('validateEmail', '', {});
  }
  validateEmailIntegration(): string {
    return this._urlFactory.createUrl('validateEmailIntegration', '', {});
  }
  getForgotUsernameRequestUserData(): string {
    return this._urlFactory.createUrl(
      'getForgotUsernameRequestUserData',
      '',
      {},
    );
  }
  downloadBobCsv(): string {
    return this._urlFactory.createUrl('downloadBobCsv', '');
  }
  downloadRfpCsv(): string {
    return this._urlFactory.createUrl('downloadRfpCsv', '');
  }
  getMaPdpPlans(): string {
    return this._urlFactory.createExtUrl('getMaPdpPlans', '', {});
  }

  getFindPharmacy2026(): string {
    return this._urlFactory.createExtUrl('getFindPharmacy2026', '', {});
  }
  getIfpHPS(): string {
    return this._urlFactory.createExtUrl('getIfpHPS', '', {});
  }
  getCSBAdam(): string {
    return this._urlFactory.createExtUrl('getCSBAdam', '', {});
  }
  getCSBAdamLeadsDashboard(): string {
    return this._urlFactory.createExtUrl('getCSBAdamLeadsDashboard', '', {});
  }
  getCSBAdamNewInsuranceUpdate(): string {
    return this._urlFactory.createExtUrl(
      'getCSBAdamNewInsuranceUpdate',
      '',
      {},
    );
  }
  getFindPharmacy2025(): string {
    return this._urlFactory.createExtUrl('getFindPharmacy2025', '', {});
  }
}
